import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { UpdateEmploymentComponent } from "./update-employment.component";
import { UpdateEmploymentResolver } from "./../utility/updateEmployeeResolver";
import { OnboardEmploymentComponent } from "../shared/onboard-employment/onboard-employment.component";

const routes: Routes = [
  {
    path: "",
    component: UpdateEmploymentComponent,    
    children: [{
      path: '',
      redirectTo: 'on-board'
    },{
      path: 'on-board',
      component: OnboardEmploymentComponent
    },{
      path: 'I-9',
      loadChildren: () => import('../i9-petitioner/i9-petitioner.module').then((mod) => mod.I9PetitionerModule),
    }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpdateEmploymentRoutingModule {}
